import { graphql } from 'react-relay';

import { AssignedTaskWindowPaginator_query$key } from '../../../relay/__generated__/AssignedTaskWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const AssignedTaskWindowPaginator_query = graphql`
  fragment AssignedTaskWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: TaskFilter }
    order: { type: TaskOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int, defaultValue: 20 }
  )
  @refetchable(queryName: "AssignedTaskWindowPaginatorRefreshQuery") {
    assignedTasks(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...TaskConnectionDataTable_taskConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<AssignedTaskWindowPaginator_query$key>, 'fragment'>;

const AssignedTaskWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={AssignedTaskWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.assignedTasks.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default AssignedTaskWindowPaginator;
